import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { CheckCircle2, Loader2, MessageCircle } from "lucide-react";
import Header from "@/components/landing/Header";
import Footer from "@/components/landing/Footer";
import { getMerchOrder } from "@/lib/merchApi";
import { formatKes } from "@/lib/merchPricing";

export default function MerchOrderConfirm() {
    const { orderId } = useParams();
    const [order, setOrder] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getMerchOrder(orderId)
            .then(setOrder)
            .finally(() => setLoading(false));
    }, [orderId]);

    if (loading) {
        return (
            <main className="min-h-screen flex items-center justify-center bg-[#FAFAFA]">
                <Loader2 className="h-8 w-8 animate-spin text-zinc-400" />
            </main>
        );
    }

    return (
        <main
            data-testid="merch-confirm-page"
            className="min-h-screen bg-[#FAFAFA] text-zinc-950"
        >
            <Header />
            <div className="pt-24 sm:pt-28 pb-16 mx-auto max-w-lg px-4 sm:px-6 text-center">
                <CheckCircle2 className="h-16 w-16 text-green-600 mx-auto mb-4" />
                <h1 className="font-display text-3xl font-black mb-2">
                    Payment confirmed
                </h1>
                <p className="text-zinc-600 mb-8">
                    Order{" "}
                    <span className="font-mono font-semibold text-zinc-950">
                        {order?.id}
                    </span>{" "}
                    is paid. {formatKes(order?.total_kes)} received via M-Pesa.
                </p>

                <div className="rounded-2xl border border-zinc-200 bg-white p-6 text-left space-y-2 text-sm mb-8">
                    <p>
                        <span className="text-zinc-500">Receipt sent to</span>{" "}
                        WhatsApp {order?.whatsapp}
                    </p>
                    {order?.mpesa_receipt && (
                        <p>
                            <span className="text-zinc-500">M-Pesa ref</span>{" "}
                            {order.mpesa_receipt}
                        </p>
                    )}
                    <p className="flex items-center gap-2 text-zinc-700 pt-2">
                        <MessageCircle className="h-4 w-4 text-green-600 shrink-0" />
                        We&apos;ll confirm print details before production.
                    </p>
                </div>

                <Link
                    to="/merch/cups"
                    className="inline-flex rounded-full bg-zinc-950 text-white px-6 py-3 text-sm font-medium hover:bg-[#E54D2E] transition-colors"
                >
                    Order again
                </Link>
            </div>
            <Footer />
        </main>
    );
}
